import {
  TURNOVER_CREATE, TURNOVER_SAVE_FAILURE, TURNOVER_SAVE_SUCCESS
} from './mutation-types'

export default {
  state: {
    turnovers: []
  },
  getters: {
    turnovers: state => {
      return state.turnovers
    }
  },
  actions: {
    [TURNOVER_CREATE] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: '/master/turnover_types', data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(TURNOVER_SAVE_FAILURE, res.data)
            } else {
              commit(TURNOVER_SAVE_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    }
  },
  mutations: {
    [TURNOVER_SAVE_FAILURE] (state, data) {
      console.log('TURNOVER_SAVE_FAILURE')
    },
    [TURNOVER_SAVE_SUCCESS] (state, data) {
      var callback = data.callback
      callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/turnover-new.js